// LandingScrollCue.js — bouncing chevron at the foot of the landing hero that says
// "there's more below" and scrolls to the assessments. Render it inside .lp-hero.
import React, { useEffect, useRef, useState } from "react";
import Icon from "../common/icons";

// Height of the fixed yellow bar, so "scrolled away" is measured from under it
const HEADER_OFFSET = 64;

const LandingScrollCue = ({ targetId = "our-assessments" }) => {
  const sentinelRef = useRef(null);
  const [atTop, setAtTop] = useState(true);

  // The landing page scrolls <body>, not the window, so watch a marker at the top of
  // the hero instead of listening for scroll events. Once it leaves, the cue fades out.
  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel || typeof IntersectionObserver === "undefined") return undefined;
    const observer = new IntersectionObserver(([entry]) => setAtTop(entry.isIntersecting), {
      rootMargin: `-${HEADER_OFFSET}px 0px 0px 0px`,
    });
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, []);

  const handleClick = () => {
    const target = document.getElementById(targetId);
    if (!target) return;
    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
  };

  return (
    <>
      <span ref={sentinelRef} className="lp-scroll-sentinel" aria-hidden="true" />
      <button
        type="button"
        className={`lp-scroll-cue${atTop ? "" : " is-hidden"}`}
        onClick={handleClick}
        aria-label="Scroll to the assessments"
        tabIndex={atTop ? 0 : -1}
      >
        <Icon name="chevron-down" size={31} strokeWidth={2} className="lp-scroll-cue-icon" />
      </button>
    </>
  );
};

export default LandingScrollCue;
